module.exports = __webpack_public_path__ + "img/dlz-banner.cb79085e.png";